import { Component, inject, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { MatIconRegistry } from "@angular/material/icon";
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Title, Meta } from '@angular/platform-browser';
import { Subscription, from, filter, take } from 'rxjs';
import { UpdateService } from './services/update.service';
import { NavigationEnd, Params, RouterOutlet } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@Capacitor/splash-screen';
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { FileTransfer } from '@capacitor/file-transfer';
import { registerPlugin } from '@capacitor/core';
// import { PushNotifications } from '@capacitor/push-notifications';
// import GpxPlugin from '../../../../ios/App/App/Plugins/GpxPlugin'
//  import { GpxOpener } from 'gpx-plugin';
import { TraceService } from '@tt-lib/services/trace.service';
import { ViewService } from '@tt-lib/services/view.service';
import { SendIntent } from "@mindlib-capacitor/send-intent";
import { ImportService } from '@tt-lib/components/trace/trace-import/import.service';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { AppEventService, PermalinkService } from '@tt-lib/services/permalink.service';
import { Router } from '@angular/router';
import { query } from '@angular/animations';
import { BackEventService } from '@tt-lib/services/back-event.service';
import { AppPromotionService } from './services/app-promotion.service';
import { BrowserSnifferService } from '@tt-lib/services/browser-sniffer.service';

// interface GpxEvent {
//   path: string;
// }

// export interface GpxPlugin {
//   addListener(
//     eventName: 'gpxFileOpened',
//     listenerFunc: (event: { path: string }) => void,
//   ): Promise<{ remove: () => void }>;
// }

//  const Gpx = registerPlugin<GpxPlugin>('GpxOpener');
//const Gpx = registerPlugin<any>('GpxOpener');
const Gpx = registerPlugin<any>('GpxOpener');

export default Gpx;

@Component({
  selector: 'tt-root',
  imports: [
    RouterOutlet,
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true
})

export class AppComponent implements OnInit, OnDestroy {
  title = 'Topomapviewer';
  // @ViewChild(TraceImportComponent) traceImportComponent!: TraceImportComponent;
  public platformName = Capacitor.getPlatform();
  private _updateServiceSubscriptions: Subscription;

  constructor(
    private matIconRegistry: MatIconRegistry,
    private translateService: TranslateService,
    public browserSniffer: BrowserSnifferService,
    private metaService: Meta,
    // updateservice: automatic update to last version
    public updateService: UpdateService,
    public _traceService: TraceService,
    private _viewService: ViewService,
    private _importService: ImportService,
    private _permalinkService: PermalinkService,
    private _router: Router,
    private appEventService: AppEventService,
    private backEventService: BackEventService,
    private appPromotionService: AppPromotionService
  ) {

    //-------------------------
    //did the app open by clicking on the app icon or was it opened by a share event or deep link via qr code?
    //-------------------------
    //deep links via e.g. qr code arrive in this listener
    App.addListener('appUrlOpen', async (data: URLOpenListenerEvent) => {
      if (data && data.url) {
        //this._permalinkService.handleIncomingUrl(data.url);
        if (this._router.navigated) {
          // WARM START: The app was already open. The router is idle.
          this.handleIntent(data.url);
        } else {
          // COLD START: The router is busy with initial navigation.
          // Wait for the first NavigationEnd event before routing.
          this._router.events.pipe(
            filter(e => e instanceof NavigationEnd),
            take(1)
          ).subscribe((event: NavigationEnd) => {
            this.handleIntent(data.url);
          });
        }

      }
    });
    //cold startup with deep link ?
    //we could already handle launch url in check below, but capacitor will call appUrlOpen above in any case
    // async () => {
    //   const appLaunchUrl: AppLaunchUrl = await App.getLaunchUrl();
    //   if (appLaunchUrl?.url) {
    //     //deep link
    //     this.handleIntent(appLaunchUrl.url);
    //   }
    //   //else no deep link, let the app do it's normal navigation
    // }

    if (this.platformName === 'android') {

      //check for share intent at startup
      this.checkForSendIntent();
      //listener for share intent
      window.addEventListener("sendIntentReceived", () => this.checkForSendIntent());

    } else if (this.platformName === 'ios') {

      // listener for opening .gpx files on ios
      // ios apps have their own sandboxed filesystem where files can be accessed, the app folder
      // files outside the app sandboxed folder are copied to the sandboxed folder 
      // the file content is passed to the listener
      from(Gpx.getPendingGpxFile()).subscribe((data: any) => {
        //console.log('sjappi gets a gpx in the component', data)
        if (data?.content) {
          const file = new File([data.content], data.filename || 'track.gpx', {
            type: 'application/gpx+xml',
          });
          this._importService.importGpxFile(file);
        }
      }
      );
      Gpx.addListener('gpxFileOpened', async (data) => {
        const file = new File([data.content], data.filename || 'track.gpx', {
          type: 'application/gpx+xml',
        });
        this._importService.importGpxFile(file);

        // document.getElementById('logpane').innerHTML += data.debug;
        // document.getElementById('logpane').innerHTML += 'gpx file opened'
        // const files = await Filesystem.readdir(
        //   {
        //     directory: Directory.Documents,
        //     path: ''
        //   }
        // );
      });

    }

    // this.matIconRegistry.setDefaultFontSetClass('material-symbols-outlined');
    // in case we have the material icon font stored locally
    this.matIconRegistry.setDefaultFontSetClass('material-icons');
    matIconRegistry.registerFontClassAlias('NGI-IGN_ICONS', 'ngi');
    //sets the overlay false

    //this adds one of these classses: ios, android, web
    document.body.classList.add(this.platformName);

    if (Capacitor.isNativePlatform()) {
      document.body.classList.add('nativePlatform');
      // const safeTop = window.visualViewport?.offsetTop || 84; // fallback to 44
      //console.log('window.visualViewport?.offsetTop): ', window.visualViewport?.offsetTop);
      //document.documentElement.style.setProperty('--safe-top', `${safeTop}px`);
      document.documentElement.style.setProperty('--safe-top', 'env(safe-area-inset-top)');
      // console.log('inset: ', window.visualViewport?.offsetTop);
      //status bar color update will be handled in theme-switch
    } else {
      //web
      this._updateServiceSubscriptions = this.updateService.initVersionUpdateChecks();
    }
  }

  private viewContainer = inject(ViewContainerRef);

  ngOnInit(): void {
    //show links to app store
    if (this.platformName === 'web' && this.browserSniffer.isPhone()) {
      const os = this.browserSniffer.getOS();
      this.appPromotionService.showPromotionBanner(os);
    }
    /*
    // let deferredPrompt;
    // window.addEventListener('beforeinstallprompt', (e) => {
    //   // Prevents the default mini-infobar or install dialog from appearing on mobile
    //   e.preventDefault();
    //   // Save the event because you'll need to trigger it later.
    //   deferredPrompt = e;
    //   // Show your customized install prompt for your PWA
    //   // Your own UI doesn't have to be a single element, you
    //   // can have buttons in different locations, or wait to prompt
    //   // as part of a critical journey.
    //   this.showInAppInstallPromotion();
    // });
    // this.metaTagService.addTags([
    //   { name: 'keywords', content: 'Angular SEO Integration, Music CRUD, Angular Universal' },
    //   { name: 'robots', content: 'index, follow' },
    //   { name: 'author', content: 'Digamber Singh' },
    //   { name: 'viewport', content: 'width=device-width, initial-scale=1' },
    //   { name: 'date', content: '2019-10-31', scheme: 'YYYY-MM-DD' },
    //   { charset: 'UTF-8' }
    // ]);
    //this.titleService.setTitle(this.title);
    */

    let metaDescription: string;
    switch (this.translateService.currentLang) {
      case 'en':
        metaDescription = "Discover Belgian topographic maps and orthophoto's online."
        break;
      case 'fr':
        metaDescription = "Découvrez toutes les cartes topographiques et orthophotos de l'IGN en ligne."
        break;
      case 'nl':
        metaDescription = "Ontdek alle topografische kaarten en orthofoto's van het NGI online."
        break;
      case 'de':
        metaDescription = "Entdecken Sie alle topografischen Karten und Orthofotos des NGI"
        break;
      default:
        metaDescription = "Discover Belgian topographic maps and orthophoto's online."
        break;
    }

    // this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
    /*  this.metaService.updateTag(
        { name: 'description', content: metaDescription },
      );*/
    // this.metaService.updateTag(
    //   { name: 'keywords', content: this.translateService.instant('meta.keywords') }
    // );
    // reference to external cookie script, annotation ignores the error otherwise will not built
    // @ts-ignore    
    /*
    if (window['NgiCookieAlertLayer']) {
      window['NgiCookieAlertLayer'].initCookieAlertLayer(this.translateService.currentLang);
    }*/
    // });

    /*    this.metaService.addTags([
          { name: 'robots', content: 'index, follow' }
        ]);
    
    */
  }

  ngAfterViewInit() {
    if (Capacitor.isNativePlatform()) {
      SplashScreen.hide();
    }
  }

  ngOnDestroy(): void {
    window.removeEventListener("sendIntentReceived", () => this.checkForSendIntent())
    this._updateServiceSubscriptions?.unsubscribe();
  }

  private async checkForSendIntent() {
    try {
      //check for share
      const result = await SendIntent.checkSendIntentReceived();
      if (result && result.url) {
        //decode the URI (Android often sends encoded content URIs)
        const fileUri = decodeURIComponent(result.url);
        this.handleIntent(fileUri);
      }
    } catch (err) {
      console.error("Error reading shared resource :", err);
    }
  }

  private async handleIntent(resourceUri: string) {
    try {

      console.log('handleIntent : ' + resourceUri);

      //uri is not always with the file extension at the end  
      if ((resourceUri.indexOf('content://') === 0 || resourceUri.indexOf('file://') === 0) /*&& resourceUri.indexOf('.gpx') === (resourceUri.length - 4)*/) {

        //const fileName = resourceUri.toLowerCase().indexOf('.gpx') === (resourceUri.length - 4) && resourceUri.lastIndexOf('/') > -1? resourceUri.substring(resourceUri.lastIndexOf('/') + 1) : 'import_' + Date.now() + '.gpx';
        const fileName = 'tmv-gpx-imported-' + Date.now() + '.gpx';

        const contents = await Filesystem.readFile({
          path: resourceUri,
          encoding: Encoding.UTF8
        });

        const file = new File([contents.data], fileName, {
          type: 'application/gpx+xml',
        });

        this._importService.importGpxFile(file);

      } else if (/^http(s)?:\/\/.+\/.+\.(gpx|GPX)/.test(resourceUri)) {

        /*
        download alert? (snackbar is not a good solution > when app opens, url changes directly > snackbar closes)
        this.snackBar.open(this.translateService.instant('file-uploader.loading') + ' : ' + resourceUri, 'ok',
          {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'top'
          });
        */
        const fileName = 'tmv-gpx-downloaded-' + Date.now() + '.gpx';

        const fileInfo = await Filesystem.getUri({
          directory: Directory.Cache,
          path: fileName
        });

        const downloadResult = await FileTransfer.downloadFile({
          url: resourceUri,
          path: fileInfo.uri
        });

        if (downloadResult && downloadResult.path === fileInfo.uri) {
          const contents = await Filesystem.readFile({
            path: fileInfo.uri,
            encoding: Encoding.UTF8
          });

          const file = new File([contents.data], fileName, {
            type: 'application/gpx+xml',
          });

          this._importService.importGpxFile(file);

        } else {
          console.log("download error, downloadResult : ");
          console.log(downloadResult);
        }

      } else if (/^http(s)?:\/\/(topomapviewer\.ngi\.be|topomapviewer\.ngi\.be-test|localhost)/.test(resourceUri)) {
          // (:[0-9]{2,4})?(\/)?(\?)?
          /*
          let relativePath = openendUrl.split('topomapviewer.ngi.be').pop();
          if (relativePath) {
            this._router.navigateByUrl(relativePath);
          }
          */
          //this._permalinkService.handleIncomingUrl(openendUrl)

          const parsedUrl = new URL(resourceUri);
          const params = parsedUrl.searchParams;
          const queryParams: Params = {};//{ [key: string]: string } 
          params.forEach((value, key) => {
            queryParams[key] = value;
          });
          const slug = parsedUrl.pathname + parsedUrl.search;
          if (slug) {
          //this._permalinkService.handleIncomingUrl(slug, queryParams)
          this._router.navigateByUrl(slug);
          //this is done below, if necessary
          //this.appEventService.universalLink$.next(queryParams);
          this._router.events.pipe(
            filter(e => e instanceof NavigationEnd),
            take(1)
          ).subscribe((event: NavigationEnd) => {
            //until now we don't have special routes in tmv that do a redirect with updated params, but the code is ready for this
            const wasRedirected = event.url !== event.urlAfterRedirects;
            if (wasRedirected) {
              //we don't use the original query params, we check again
              this._permalinkService.getParams().pipe(take(1)).subscribe(params => {
                //if (params['trace'] || params['tracetab']) 
                this.appEventService.universalLink$.next(params);
              });
            } else if (Object.keys(queryParams).length > 0) {
              //original query params can be used
              this.appEventService.universalLink$.next(queryParams);
            }
          });
          }

      } else {
        console.error('Uri not supported :', resourceUri);
      }

    } catch (err) {
      console.error("Error reading incoming resource:", err);
    }
  }
} 
